module.exports = __webpack_public_path__ + "img/crowd1.0a6455d8.png";